import { createSlice, Dispatch, PayloadAction } from '@reduxjs/toolkit';
import { pollWindowVariable } from '@mooncake/mooncake-gateway-core/utils';
import { EnvironmentValue } from '@mooncake/mooncake-gateway-core/types';
import Api from '@mooncake/mooncake-gateway-ecom';
import { fetchUssSubscriptionsV2 } from '@mooncake/mooncake-gateway-ecom/events/ussSubscriptions';
import { ISubscription } from '../types/subscription';

export interface IUserState {
  loading: boolean;
  error: string | null;
  user: {
    subscriptions: ISubscription[];
  };
}

const userSlice = createSlice({
  name: 'user',
  initialState: {
    loading: false,
    error: null,
    user: {
      subscriptions: [],
    },
  } as IUserState,
  reducers: {
    fetchStart(state) {
      state.error = null;
      state.loading = true;
    },
    fetchEnd(state) {
      state.loading = false;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    setUserSubscriptions(state, action: PayloadAction<ISubscription[]>) {
      state.user.subscriptions = action.payload;
    },
  },
});

export const { fetchStart, fetchEnd, setError, setUserSubscriptions } = userSlice.actions;

export const fetchCurrentUserSubscription = () => (dispatch: Dispatch) => {
  return new Promise((resolve, reject) => {
    pollWindowVariable('MFE_API_ENV').then((value) => {
      const apiEnvironment = value as string;
      Api.environment = (apiEnvironment.toLowerCase() as EnvironmentValue) || 'dev';
      Api.appId = '21a6b8b8-0e1a-4308-b2fc-bfd3470bd4d6';
      dispatch(fetchStart());
      setTimeout(() => {
        dispatch(fetchEnd());
      }, 10000);
      fetchUssSubscriptionsV2(
        {
          additionalParams: "and type eq 'ibex' &extraFields[]=products",
        },
        (response) => {
          dispatch(fetchEnd());
          if (response?.resource?.data) {
            dispatch(setUserSubscriptions(response.resource.data));
            resolve(response.resource);
          } else {
            console.error(response);
            dispatch(setError('Unable to fetch user subscriptions.'));
            reject(response);
          }
        }
      )();
    });
  });
};

export default userSlice.reducer;
